import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@services/authentication';
import { Representation } from '@services/api-client/responses/login-response.type';
import { DefaultNavigationService } from '@services/default-navigation';

@Component({
    selector: 'app-representation-dropdown',
    templateUrl: './representation-dropdown.component.html',
    styleUrls: ['./representation-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, NgbDropdownModule]
})
export class RepresentationDropdownComponent implements OnInit {
    public representingName: string;
    public representationAlternatives: Representation[];
    public currentRepresentationId: string;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly defaultNavigationService = inject(DefaultNavigationService);

    public ngOnInit(): void {
        const user = this.authenticationService.getUser();
        this.representingName = user.representing.name;
        this.representationAlternatives = user.representationAlternatives;
        this.currentRepresentationId = user.representing.id;
    }

    public changeRepresentation(representation: Representation): void {
        this.authenticationService.changeRepresentation(representation.id).subscribe(() => {
            this.defaultNavigationService.reloadAfterRepresentationChange();
        });
    }
}
